import { useSelector } from "react-redux";
import {  onDragStart, onDragEnd, onDragEnter, onDragLeave } from "../../util/helper/helperFunctions";
import "../../assets/css/Status/activeShipment.css";

const ActiveShipmentMetrics = ({ scrollable }) => {
  const { loading, data } = useSelector(
    (state) => state.dashboard.activeShipmentMetrics
  );

  return (
    <div
      draggable
      onMouseDown={(event) => onDragStart(event)}
      onMouseUp={(event) => onDragEnd(event)}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      id="active-shipment-status-container"
      className="active-shipment-status-container"
    >
      <div className="active-shipment-header-section">
        <h4>Active Shipment Metrics</h4>
      </div>
      {loading ? (
        <div
          className={`active-shipment-status-section active-shipment-loader-alignment ${
            scrollable ? "active-shipment-status-section-wrap" : ""
          } `}
        >
          <div className="rm-loader">
            <h4>Loading...</h4>
            <div className="spinner"></div>
          </div>
        </div>
      ) : (
        <div
          className={`active-shipment-status-section ${
            scrollable ? "active-shipment-status-section-wrap" : ""
          } `}
        >
          {data?.map((status, index) => {
            return Object.entries(status).map(([key, value]) => {
              return (
                <div key={index} className="active-shipment-status-box">
                  <div className="active-shipment-status-top-section">
                    <p>{value ? value : "-"}</p>
                  </div>
                  <div className="active-shipment-status-bottom-section">
                    <p>{key}</p>
                  </div>
                </div>
              );
            });
          })}
        </div>
      )}
    </div>
  );
};

export default ActiveShipmentMetrics;
